// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Fst7","savePackageButton":"ClientWallet_savePackageButton__2K-fH"};